"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PageNumberingInfo = void 0;
var list_level_properties_1 = require("../../../../core/model/numbering-lists/list-level-properties");
var PageNumberingInfo = (function () {
    function PageNumberingInfo() {
        this.chapterSeparator = "";
        this.numberingFormat = list_level_properties_1.NumberingFormat.None;
        this.firstPageNumber = -1;
        this.continueNumbering = true;
    }
    PageNumberingInfo.prototype.copyFrom = function (obj) {
        this.chapterSeparator = obj.chapterSeparator;
        this.chapterHeaderStyle = obj.chapterHeaderStyle;
        this.numberingFormat = obj.numberingFormat;
        this.firstPageNumber = obj.firstPageNumber;
        this.continueNumbering = obj.continueNumbering;
    };
    return PageNumberingInfo;
}());
exports.PageNumberingInfo = PageNumberingInfo;
